module.exports = __webpack_public_path__ + "img/listing-info.6c4f608f.jpg";